<template>
  <v-container
    class="py-1"
    fluid
  >
    <v-row
      ref="categoriesTabs"
      v-resize="onResize"
      v-scroll="onScroll"
    >
      <v-col
        id="categoriesListAffixContainer"
        ref="categoriesListContainer"
        class="px-0"
        cols="12"
      >
        <div class="d-flex flex-nowrap">
          <div class="d-inline-flex">
            <v-btn
              class="px-1 mr-1 indigo"
              dark
              height="48"
              min-height="48"
              min-width="48"
              width="48"
              @click="showSelectCategoryDialog"
            >
              <v-icon large>
                {{ $t('Pos.SelectCategoryDialog.Toolbar.Icon') }}
              </v-icon>
            </v-btn>
          </div>

          <div
            ref="tabsContainer"
            class="d-inline-flex"
          >
            <v-tabs
              ref="tabs"
              v-model="selectedTab"
              :slider-color="selectedCategoryColor || 'red'"
              class="rounded d-inline-flex"
              color="white"
              dark
              show-arrows
              slider-size="4"
            >
              <template v-for="(item, index) in activeCategories">
                <v-tab
                  :key="`category-${item.Id}-${index}`"
                  class="px-2"
                  @click="onCategorySelected(item)"
                >
                  {{ getTranslatedField(item, 'Name') | sanitizeDiacritics }}
                </v-tab>
              </template>
            </v-tabs>
          </div>
        </div>
      </v-col>
    </v-row>

    <select-category-dialog
      :active-categories="activeCategories"
      :active-category="activeCategory"
      :visible.sync="selectCategoryDialogVisible"
      @on-select-category="onCategorySelected"
    />
  </v-container>
</template>

<script>
import Translatable from '@/mixins/translatable'
import Resize from 'vuetify/src/directives/resize'
import SelectCategoryDialog from '@/components/pos/SelectCategoryDialog.vue'

export default {
  name      : 'PosCatalogCategoriesTabs',
  components: {SelectCategoryDialog},
  directives: {Resize},
  mixins    : [Translatable],
  props     : {
    activeCategories: {
      type   : Array,
      default: undefined
    },
    activeCategory: {
      type   : Object,
      default: undefined
    }
  },
  data() {
    return {
      selectedTab                : null,
      selectedCatalog            : null,
      selectedSourceTypeId       : null,
      selectCategoryDialogVisible: false
    }
  },
  computed: {
    selectedCategoryColor() {
      const color = this.activeCategories[this.selectedTab]?.Color
      return color ? `#${color}` : ''
    }
  },
  watch: {},
  beforeCreate() {
  },
  created() {
    this.$bus.$on('cart:order-source-type-selected', this.onCatalogSelected)
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
    this.$bus.$off('cart:order-source-type-selected', this.onCatalogSelected)
  },
  destroyed() {
  },
  methods: {
    showSelectCategoryDialog() {
      this.selectCategoryDialogVisible = true
    },

    onCategorySelected(category) {
      const categoryIndex = this.activeCategories.findIndex(c => c.Id === category.Id)
      if (categoryIndex > -1) this.selectedTab = categoryIndex
      this.$emit('on-select-category', category)
    },

    onCatalogSelected(sourceTypeId, catalog) {
      if (this.selectedCatalog?.Id !== catalog?.id || this.selectedSourceTypeId !== sourceTypeId) this.selectedTab = null

      this.selectedSourceTypeId = sourceTypeId
      this.selectedCatalog = catalog
    },

    onResize(e) {
      this.onScroll()
    },

    onScroll(e) {
      this.offsetTop = window.pageYOffset || document.documentElement.scrollTop
      if (this.$refs.categoriesTabs) {
        this.$refs.categoriesTabs.style = 'position: relative;'
        this.$refs.categoriesTabs.style = this.offsetTop > 280 ? 'z-index: 1; position: fixed; top: 64px; width: ' + (this.$refs.categoriesTabs.clientWidth) + 'px;' : 'position: relative; width: auto;'
        if (this.$refs.tabsContainer) this.$refs.tabsContainer.style = 'max-width: ' + (this.$refs.categoriesTabs.clientWidth - 52) + 'px;'
      }
    }
  }
}
</script>

<style scoped>

</style>
